export default [
    {
      path: '/admin/return-to-vendors',
      name: 'return-to-vendor',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/return-to-vendor/index.vue')
    },
    {
      path: '/admin/return-to-vendors/create',
      name: 'return-to-vendor-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/return-to-vendor/create.vue')
    },
    {
      path: '/admin/return-to-vendors/:id/edit',
      name: 'return-to-vendor-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/return-to-vendor/edit.vue')
    }
  ]
  